import { render, staticRenderFns } from "./ServicosRecolhimentoNotasToggle.vue?vue&type=template&id=188794a6&scoped=true&"
import script from "./ServicosRecolhimentoNotasToggle.vue?vue&type=script&lang=js&"
export * from "./ServicosRecolhimentoNotasToggle.vue?vue&type=script&lang=js&"
import style0 from "./ServicosRecolhimentoNotasToggle.vue?vue&type=style&index=0&id=188794a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188794a6",
  null
  
)

export default component.exports